import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Tabs, Tab, Dialog, DialogTitle, DialogContent } from '@mui/material';
import './base-content.scss';
import QuickStartComponent from '../bottom-tabs/quick-start/quick-start-component';
import ProductInfoComponent from '../bottom-tabs/product-information/product-info-component';
import { setActiveBottomTab } from '../../../store/landing-slice';
import { contactSupportLink, videoTutorialLink } from '../constant';

export default function BottomTabs() {
  const { activeBottomTab } = useAppSelector((state) => state.landing);
  const appDispatch = useAppDispatch();
  const [value, setValue] = useState(-1);
  const [open, setOpen] = useState(false);
  const { segmentDetailsData } = useAppSelector((state) => state.landing);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // eslint-disable-next-line dot-notation
    if(event.target['innerText'] === 'Quick Start' || event.target['innerText'] === 'Product Information'){
      setValue(newValue);
      setOpen(true);
    }
    // set the activeBottomTab redux var based on user click
    // eslint-disable-next-line dot-notation
    appDispatch(setActiveBottomTab(event.target['innerText']));
  };
  // reset the activeBottomTab on close of popup window
  const handleCloseDialog = () => {
    setOpen(false);
    setValue(-1);
    appDispatch(setActiveBottomTab(''));
  };
  // when the activeBottomTab is set
  useEffect(() => {
    if (activeBottomTab === 'Quick Start') {
      setOpen(true);
      setValue(0);
    }
    else if(activeBottomTab === 'Product Information'){
      setOpen(true);
      setValue(1);
    }
    else if(activeBottomTab === 'Video Tutorials'){
      setOpen(false);
      setValue(-1);
    } 
    else if(activeBottomTab === 'Contact Support'){
      setOpen(false);
      setValue(-1);
    }
  }, [activeBottomTab]);

  // mapping object for popup styling
  const popupStyles = {
    'Product Information': {
      height: '80vh',
      width: '70%',
      maxHeight: 'fit-content',
      maxWidth: 'none',
      overflowY: 'unset'
    },
    'Quick Start': {
      height: '98vh',
      width: '70%',
      maxHeight: 'none',
      maxWidth: 'none',
      overflowY: 'auto'
    },
    // 'Video Tutorials': {
    //   height: '30vh',
    //   width: '40vh'
    // },
    // 'Contact Support': {
    //   height: '30vh',
    //   width: '40vh'
    // }
  };

  // custom styling for tabs
  const tabStyle = {
    color: '#0000A0',
    textTransform: 'none',
    borderBottom: '0.5px solid #0000A0',
    fontSize: '11px',
    justifyContent: 'flex-end',
    padding: '6px 16px',
    marginLeft: '10px'
  };

  // styles based on the active tab
  const dialogStyles = {
    PaperProps: {
      height: popupStyles[activeBottomTab]?.height || '80vh',
      width: popupStyles[activeBottomTab]?.width || '70%',
      maxHeight: popupStyles[activeBottomTab]?.maxHeight || 'fit-content',
      maxWidth: popupStyles[activeBottomTab]?.maxWidth || 'none',
      overflowY: popupStyles[activeBottomTab]?.overflowY || 'unset'
    },
    dialogTitle: {
      fontSize: '16px',
      fontWeight: '700',
      margin: activeBottomTab === 'Product Information' ? 'auto 0' : '0px',
      padding: activeBottomTab === 'Product Information' ? '16px 24px 0px 24px' : '16px 24px'
    },
    dialogContent: {
      height: activeBottomTab === 'Product Information' ? '100%' : '90%',
      overflowY: activeBottomTab === 'Product Information' ? 'unset' : 'auto'
    }
  };

  const getDialogContent = () => {
    switch (value) {
      case 0:
        return <QuickStartComponent />;
      case 1:
        return <ProductInfoComponent />;
      case 2:
        return '';
      case 3:
        return '';
      default:
        return '';
    }
  };

  return (
    <div className='tabs-container'>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label='tabs example'
        TabIndicatorProps={{ sx: { backgroundColor: 'primary.main' } }}
      >
        <Tab
          label='Quick Start'
          id='tab-0'
          aria-controls='tabpanel-0'
          className='tab-style'
        />
        <Tab
          label='Product Information'
          id='tab-1'
          aria-controls='tabpanel-1'
          className='tab-style'
        />
        <Tab
          label='Video Tutorials'
          id='tab-2'
          aria-controls='tabpanel-2'
          className='tab-style'
          onClick={() => window.open(videoTutorialLink, "_blank")}
        />
        <Tab
          label='Contact Support'
          id='tab-3'
          aria-controls='tabpanel-3'
          className='tab-style'
          onClick={() => window.open(contactSupportLink, "_blank")}
        />
      </Tabs>

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby='dialog-title'
        fullWidth
        maxWidth='sm'
        PaperProps={{ sx: dialogStyles.PaperProps }}
      >
        <DialogTitle id='dialog-title' sx={dialogStyles.dialogTitle}>
          {activeBottomTab === 'Product Information'
            ? `${activeBottomTab} - ${segmentDetailsData.source_name}`
            : activeBottomTab}
        </DialogTitle>
        <DialogContent sx={dialogStyles.dialogContent}>
          {getDialogContent()}
        </DialogContent>
      </Dialog>
    </div>
  );
}
